import script from "./Grade.vue?vue&type=script&setup=true&lang=ts"
export * from "./Grade.vue?vue&type=script&setup=true&lang=ts"

import "./Grade.vue?vue&type=style&index=0&id=a6ff1582&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6ff1582"]])

export default __exports__